<template lang="pug">
	.station-list.tb-padding
		ListView.full-width(ref="listView", initialView="table", :searchVisible="false", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="() => items", :getData="loadData", :columns="columns")
			template(v-slot:listing-cell-template="{ data }")
				.flex-row.space.align-center
					DxButton(v-if="allowEdit", :disabled="data.FccId !== null" icon="close", @click="removeStation(data)")
					a(v-if="allowEdit", @click="editItem(data)")
						span {{data.Name}}
					span(v-else) {{data.Name}}
			template(slot="left-actions")
				.flex-row.space.align-center
					.font-large {{$tCaption('Stations')}}
					DxButton(v-if="allowEdit", icon="plus", @click="showStationPopup")
		.add-button
			DxButton(v-if="allowEdit", icon="plus", type="default", @click="showStationPopup")
		Popup(v-if="stationPopup.visible && allowEdit", :popupVisible="stationPopup.visible", :autosize="true")
			ListView.full-width(ref="popupListView", initialView="table", :height="380", :searchVisible="true", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="() => allStationItems", :getData="loadAllStationsData", :columns="stationPopup.columns")
				template(v-slot:listing-cell-template="{ data }")
					.flex-row.space.align-center
						DxButton(:icon="stationPopup.added.indexOf(data.Oid) > -1 ? 'check' : 'plus'", type="normal", @click="toggleStation(data)")
						span {{data.Name}}
				.flex-row.space(slot="left-actions")
					DxButton(stylingMode="text", :text="$tCaption('Create new station')", @click="createNewStation")
			.flex-row.space(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="stationPopup.visible = false")
				DxButton(:text="$tCaption('Add stations')", type="default", @click="doAddStations", :disabled="stationPopup.processing")
</template>

<script>
    import ListView from 'app-core/ListView.vue';
    import DxButton from 'devextreme-vue/button';
    import Popup from 'app-core/Popup.vue';

    export default {
	translationCategory: 'station.List',
	components: { ListView, DxButton, Popup },
	data() {
		return {
			result: null,
			allStationsResult: null,
            columns: [
                {dataField: 'name', caption: () => this.$tCaption('Name'), cellTemplate: 'listing-cell-template', serverField: 'Name'},
                {dataField: 'CallLetters', caption: () => this.$tCaption('Call letters')},
                {dataField: 'FrequencyFormatted', caption: () => this.$tCaption('Frequency')},
                {dataField: 'Slogan', caption: () => this.$tCaption('Slogan')},
                {dataField: 'BandName', caption: () => this.$tCaption('Band')},
                {dataField: 'Website', caption: () => this.$tCaption('Website')},
                {dataField: 'ContryName', caption: () => this.$tCaption('Country')},
                {dataField: 'ZoneName', caption: () => this.$tCaption('Zone')},
                {dataField: 'DmaZoneName', caption: () => this.$getSetting('custom.nielsenDma.caption') || this.$tCaption('DMA Zone'), visible: this.$getSetting('custom.nielsenDma.visible') !== false},
                {dataField: 'MsaZoneName', caption: () => this.$tCaption('MSA Zone')},
                {dataField: 'FormatNames', caption: () => this.$tCaption('Format')}
            ],
			stationPopup: {
				visible: false,
				columns: [
					{ dataField: 'name', caption: () => this.$tCaption('Name'), cellTemplate: 'listing-cell-template', serverField: 'Name'  },
					{ dataField: 'CallLetters', caption: () => this.$tCaption('Call letters') },
					{ dataField: 'FrequencyFormatted', caption: () => this.$tCaption('Frequency') },
					{ dataField: 'Slogan', caption: () => this.$tCaption('Slogan') },
					{ dataField: 'BandName', caption: () => this.$tCaption('Band') },
					{ dataField: 'ZoneName', caption: () => this.$tCaption('Zone') },
					{ dataField: 'DmaZoneName', caption: () => this.$getSetting('custom.nielsenDma.caption') || this.$tCaption('DMA Zone'), visible: this.$getSetting('custom.nielsenDma.visible') !== false },
					{ dataField: 'MsaZoneName', caption: this.$tCaption('MSA Zone') },
					{ dataField: 'FormatNames', caption: this.$tCaption('Format') }
				],
				added: [],
				processing: false
			}
		};
	},
	computed: {
        bandTypes() {
            return [
                this.$tCaption('FM'),
                this.$tCaption('AM'),
                this.$tCaption('LP'),
                this.$tCaption('DAB'),
                this.$tCaption('HD'),
                this.$tCaption('DRM'),
                this.$tCaption('Stream'),
                this.$tCaption('Podcast'),
                this.$tCaption('Instore'),
                this.$tCaption('Pos'),
            ]
        },
		items() {
			return this.result && this.result.Results.map(f => ({
				...f,
				BandName: this.bandTypes[f.StationBand],
				ContryName: f.Country && f.Country.Name,
				DmaZoneName: f.DmaZone && f.DmaZone.Name,
				MsaZoneName: f.MsaZone && f.MsaZone.Name,
				ZoneName: f.Zone && f.Zone.Name,
				Formats: f.Formats && f.Formats.map(f => f.Name).join(', '),
				FrequencyFormatted: f.StationBand === 0 && f.Frequency > 200 ? f.Frequency / 10 : f.Frequency
			}));
		},
		allStationItems() {
			return this.allStationsResult && this.allStationsResult.Results.map(f => ({
				...f,
				BandName: this.bandTypes[f.StationBand],
				ContryName: f.Country && f.Country.Name,
				DmaZoneName: f.DmaZone && f.DmaZone.Name,
				MsaZoneName: f.MsaZone && f.MsaZone.Name,
				ZoneName: f.Zone && f.Zone.Name,
				Formats: f.Formats && f.Formats.map(f => f.Name).join(', '),
				FrequencyFormatted: f.StationBand === 0 && f.Frequency > 200 ? f.Frequency / 10 : f.Frequency
			}));
		},
		allowEdit() {
			return (this.$auth.isStationOwner() && this.$auth.isDirector()) || this.$auth.isAdmin();
		}
	},
	methods: {
		showStationPopup() {
			this.stationPopup.added = [];
			this.stationPopup.visible = false;
			setImmediate(() => {
				if (this._isDestroyed) return;
				this.stationPopup.visible = true;
			});
		},
		removeStation(data) {
			this.$confirmMessage({
				title: this.$tCaption('Confirm action', '@actions'),
				text: this.$tCaption('Are you sure you want to remove station?'),
				handler: () => {
					this.$Data.postExternalApi('Company/RemoveStationsFromCompany',  {
						ObjectId: this.$auth.companyId(),
						ItemIds: [data.Oid]
					}).then(r => {
						if (r.Success) {
							this.$notifySuccess(this.$tCaption('Station removed'));
							this.$refs.listView.reload();
						} else {
							this.$notifyError(r.ErrorMessage);
						}
					});
				}
			});
		},
		toggleStation(station) {
			if (__DEBUG__)
				console.debug('Toggle station', { station });
			this.$Data.toggleSelectedIdInArray(station.Oid, this.stationPopup.added);
		},
		doAddStations() {
			if (__DEBUG__)
				console.debug('Add stations', { added: this.stationPopup.added });
			this.stationPopup.processing = true;
			this.$Data.postExternalApi('Company/AddStationsToCompany', {
				ObjectId: this.$auth.companyId(),
				ItemIds: this.stationPopup.added
			}).then(r => {
				if (this._isDestroyed) return;
				if (r.Success) {
					this.$refs.listView.reload();
					this.stationPopup.visible = false;
				} else {
					this.$notifyError(r.ErrorMessage);
				}
			}).finally(() => this.stationPopup.processing = false);
		},
		createNewStation() {
			if (__DEBUG__)
				console.debug('Create new station');
			this.$router.push({ name: 'station-detail', params: { id: 'new' } });
		},
		loadData(pageIndex, size, sortings) {
			return this.$Data.getExternalCompanyStations(pageIndex, size, sortings).then(r => {
				if (this._isDestroyed) return;
				if (__DEBUG__)
					console.debug('Stations loaded', { r });
				this.result = r;
				return r;
			});
		},
		loadAllStationsData(pageIndex, size, sortings) {
			return this.$Data.getExternalStations(pageIndex, size, { ...sortings, onlyMyStations: false, allCountries: false, unlinkedOnly: true }).then(r => {
				if (this._isDestroyed) return;
				if (__DEBUG__)
					console.debug('Stations loaded', { r });
				this.allStationsResult = r;
				return r;
			});
		},
		editItem(data) {
			if (__DEBUG__)
				console.debug('Edit station', data);
			this.$router.push({ name: 'station-detail', params: { id: data.Oid } });
		}
	}
};
</script>
<style lang="scss">
	.station-list {
		position: relative;

		.add-button {
			position: fixed;
			display: flex;
			align-items: center;
			justify-content: center;
			bottom: 40px;
			right: 40px;
			border-radius: 100px;
			width: 40px;
			height: 40px;
		}
	}
</style>
